import React from 'react';
import { RichText, Text, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import ChineseLanguageBanner from '@component/ChineseLanguageBanner';

const ChineseLanguageBannerComponent = (props) => {
  const isWindowContext = typeof window !== 'undefined';
  const target = props.fields?.link?.value?.target === '' ? '_self' : props.fields?.link?.value?.target;

  if (
    props.sitecoreContext.language.includes('en') &&
    isWindowContext &&
    (window.navigator.languages.includes('zh-TW') || window.navigator.languages.includes('zh'))
  ) {
    return (
      <section>
        <ChineseLanguageBanner
          title={<Text field={props.fields?.title} />}
          ctaLabel={props.fields?.buttonlabel.value}
          message={<RichText field={props.fields?.copy} />}
          ctaLink={props.fields?.link?.value?.href}
          handleClick={() => {
            const href = props.fields?.link?.value?.href + props.fields?.link?.value?.querystring;

            window.open(href, target);
          }}
        />
      </section>
    );
  }
  return null;
};
export default withSitecoreContext()(ChineseLanguageBannerComponent);
